import { useParams } from "common/components/Form/ParamsContext";
import { getNotificationAddressService } from "./notificationAddressApi";

export default function useNotificationAddressList() {
  const params = useParams();
  const scope = {};
  const editUrl = "notificationAddresss/";
  const service = getNotificationAddressService(scope);
  return { ...service, params, scope, editUrl };
}
